<h1 mat-dialog-title>Review Output Filenames</h1>
<mat-dialog-content>
  @if (entries.length === 0) {
    <p class="empty">No filenames to preview for the selected products and formulas.</p>
  }
  @if (entries.length > 0) {
    <table mat-table [dataSource]="entries" class="filenames-table">
      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Product</th>
        <td mat-cell *matCellDef="let entry">{{ entry.productId }}</td>
      </ng-container>
      <ng-container matColumnDef="formula">
        <th mat-header-cell *matHeaderCellDef>Formula</th>
        <td mat-cell *matCellDef="let entry">{{ entry.outputFormulaName }}</td>
      </ng-container>
      <ng-container matColumnDef="generated">
        <th mat-header-cell *matHeaderCellDef>Generated Filename</th>
        <td mat-cell *matCellDef="let entry" class="filename">{{ entry.generated }}</td>
      </ng-container>
      <ng-container matColumnDef="templateCurrent">
        <th mat-header-cell *matHeaderCellDef>Template Current</th>
        <td mat-cell *matCellDef="let entry">
          @if (entry.templateCurrent) {
            <mat-icon class="current-icon">check_circle</mat-icon>
          }
          @if (!entry.templateCurrent) {
            <mat-icon class="outdated-icon">warning</mat-icon>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
